import React, { FC, useCallback, useState } from 'react'
import { Grid } from '@mui/material'
import { ISfBankAccount, ISfWallet } from '@sparling/financial-common'

import { Modal } from '../../../../components/Modal'
import { IColumns, IDataItem, TableComponent } from '../../../../components/Table'
import { Loader } from '../../../../components/Loader'

interface Props {
  isOpen: boolean
  modalClose: () => void
  title: string
  columns: IColumns[]
  data: IDataItem<ISfBankAccount | ISfWallet>[]
  meta: {
    currentPage: number
    itemsPerPage: number
    itemCount: number
    totalItems: number
    totalPages: number
  }
  loading: boolean
  loadingFunc?: (value: number) => void
  assignHandle: (value: number[]) => void
  width: number
}

export const UserSparlingAccountModal: FC<Props> = ({
  isOpen,
  modalClose,
  title,
  columns,
  data,
  meta,
  loading,
  loadingFunc,
  assignHandle,
  width,
}) => {
  const [idsToAssign, setIdsToAssign] = useState<number[]>([])

  const assignIdHandle = useCallback((id: number) => {
    setIdsToAssign((prev) => (prev.includes(id) ? prev.filter((p) => p !== id) : [...prev, id]))
  }, [])

  const closeHandle = useCallback(() => {
    setIdsToAssign([])
    modalClose()
  }, [modalClose])

  if (loading) {
    return <Loader />
  }

  return (
    <Modal
      title={title}
      isOpen={isOpen}
      modalClose={closeHandle}
      width={width}
      isSubmitDisabled={!idsToAssign.length}
      onSubmit={() => assignHandle(idsToAssign)}
    >
      <Grid container>
        <TableComponent
          columns={columns}
          data={data}
          onAdd={assignIdHandle}
          isShowActionBtn={true}
          isShowRemoveIcon={false}
          isShowEditIcon={false}
          isShowInfoIcon={false}
          loading={loading}
          checkedIds={idsToAssign}
          loadData={loadingFunc}
          params={meta}
        />
      </Grid>
    </Modal>
  )
}
